export const DOMAIN = 'auth.user';
